import { useEffect } from "react";


function ScrollTop(){
    useEffect(()=>{
        window.scrollTo({
            left:0,
            top:0,
            behavior:"instant"
        })
    })
    
    return null;
}

export default ScrollTop;